/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import {
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  FormCheck,
  OverlayTrigger,
  Tooltip,
  Image,
} from 'react-bootstrap';
import {
  CheckCircleIcon,
  DotsHorizontalIcon,
  EyeIcon,
  InformationCircleIcon,
  ShieldExclamationIcon,
  UserRemoveIcon,
  XCircleIcon,
  PencilIcon,
} from '@heroicons/react/solid';
import { StorageModule } from '@vlinder-web/storage-module-react';

export interface ToggleActionProps {
  status: string;
  onTogglePress?(key: string): void;
}

export const ToggleAction = (props: ToggleActionProps) => {
  const { status, onTogglePress } = props;
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');
  const userRole = userProfile?.role?.find((item) => item?.name === 'owner');

  const onToggleClick = (key: string) => {
    console.log('key : id', key);
    onTogglePress && onTogglePress(key);
  };
  const _getToggleItems = () => {
    if (status === 'created' || status === 'invited' || status === 'verified') {
      return (
        <Dropdown.Item
          className="d-flex align-items-center"
          onClick={() => onToggleClick('re-invite')}
        >
          <CheckCircleIcon className="dropdown-icon text-gray-400 me-2" />
          Reinvite
        </Dropdown.Item>
      );
    } else if (status === 'active' && userRole?.name === 'owner') {
      return (
        <Dropdown.Item
          className="d-flex align-items-center"
          onClick={() => onToggleClick('suspend')}
        >
          <ShieldExclamationIcon className="dropdown-icon text-gray-400 me-2" />
          Suspend
        </Dropdown.Item>
      );
    } else if (status === 'suspended' && userRole?.name === 'owner') {
      return (
        <Dropdown.Item
          className="d-flex align-items-center"
          onClick={() => onToggleClick('activate')}
        >
          <ShieldExclamationIcon className="dropdown-icon text-gray-400 me-2" />
          Activate
        </Dropdown.Item>
      );
    } else return null;
  };

  return (
    <Dropdown as={ButtonGroup}>
      <Dropdown.Toggle
        as={Button}
        split
        variant="link"
        className="text-dark m-0 p-0"
      >
        <DotsHorizontalIcon className="icon icon-xs" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start mt-2 py-1">
        <Dropdown.Item
          className="d-flex align-items-center"
          onClick={() => onToggleClick('view')}
        >
          <EyeIcon className="dropdown-icon text-gray-400 me-2" />
          View
        </Dropdown.Item>
        {/* <Dropdown.Item
          className="d-flex align-items-center"
          onClick={() => onToggleClick('edit')}
        >
          <PencilIcon className="dropdown-icon text-gray-400 me-2" />
          Edit
        </Dropdown.Item> */}
        {_getToggleItems()}
      </Dropdown.Menu>
    </Dropdown>
  );
};
